<template>
    <!-- featuredCourseList 中index和教师端保持一致且写死 -->
    <div class="featured-content">
        <div class="featured-index">
            <div class="featured-left"  v-if="this.$route.path=='/qualityCourse/featured'">
                
                <div class="featured-topbox">
                    <span>资源类型：</span>
                    <span :class="classId === 0 ? 'class-item' : ''" @click="changeType(0)">全部</span>
                    <span :class="classId === item.id ? 'class-item' : ''" @click="changeType(item.id)"
                          v-for="(item,index) in newTypeList" :key="index">{{item.name}}</span>
                </div>
                <el-scrollbar class="featured-top" :native="false">
                    <div class="featured-mainbox">
                        <div class="mainbox-list" v-if="showPeitao.length > 0">
                            <div class="dragg-box">
                                <div class="mainbox-list-item1" v-for="(item,index) in showPeitao.slice((this.cailiao.page-1)*this.cailiao.size,this.cailiao.page*this.cailiao.size)" @click="goToCourseWare(item)" :key="index">
                                    <div class="mainbox-list-item">
                                        <div class="pic-box" v-if="item.material_type_id">
                                        <img :src="newTypePic[item.material_type_id - 1].src" alt="">
                                    </div>
                                    <div class="pic-box" v-else>
                                        <img :src="newTypePic[item.material_type_id].src" alt="">
                                    </div>
                                    <div class="item-title">{{item.resource_title}}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="mainbox-list-else" v-else>
                            <img src="@/assets/teacherPeitaoCl/supportingInformationNoData.png" alt="">
                            <div class="no-data">暂无数据</div>
                        </div>
                        <div class="page-box">
                            <el-pagination
                                    
                                    v-if="showPeitao.length > 0"
                                    @size-change="handleSizeChange"
                                    @current-change="handleCurrentChange"
                                    :current-page="cailiao.page"
                                    :page-size="cailiao.size"
                                    layout="prev, pager, next, jumper"
                                    :total="cPeitao.length">
                            </el-pagination>
                        </div>
                    </div>
                </el-scrollbar>

            </div>
            <div class="featured-left-copy" v-else>
                <router-view  v-if="activeName === 'studentFeatured' || 'studentCourseIndex'"
                             :courseInfos="courseInfos" :nodeIndex="nodeIndex" :chapterIndex="chapterIndex" />
                    <router-view v-else />
            </div>
            <div class="resource_navigation" >
                    <el-scrollbar class="featured-right" :native="false">
                        <div class="resource">
                            <div class="resourse_item"  v-for="(item, index) in featuredCourseList"
                                @click="getResourceList(item.index,index,item)" :key="index">

                                <div slot="reference" v-if="index>5" class="inner-box"
                                    :class="{ active_resourse_item: activeFeaturedIndex == index }">
                                    <i class="iconfont" style="font-size: 22px;" v-html="item.icon"></i>
                                    <div class="resourse_title">{{ item.title }}</div>

                                    <i class="iconfont lock" v-if="item.index !=10 && item.lock" >&#xe669;</i>
                                    <!-- <i class="iconfont no-lock"  v-if="item.index !=10 && !item.lock">&#xe6e6;</i> -->
                                </div>
                                <el-popover  :ref="'pop'+ index" v-else popper-class="monitor-yt-popver" placement="left" width="200"
                                    trigger="click">
                                    <div slot="reference" class="inner-box"
                                        :class="{ active_resourse_item: activeFeaturedIndex == index }">
                                        <i class="iconfont" style="font-size: 22px;" v-html="item.icon"></i>
                                        <div class="resourse_title">{{ item.title }}</div>

                                        <i class="iconfont lock" v-if="item.index !=10 && item.lock" >&#xe669;</i>
                                        <!-- <i class="iconfont no-lock"  v-if="item.index !=10 && !item.lock">&#xe6e6;</i> -->
                                    </div>
                                  
                                        <div class="popover-item" :class="{'active-popover-item' : activePopoverIndex == poverIndex}" v-for="(item ,poverIndex) in showResourseList" :key="poverIndex">
                                        <div @click="goToCourseWare(item,index,poverIndex)">{{ item.title }}</div>
                                    </div>
                            
                                    
                                    <div class="no-data" v-if="showResourseList.length === 0">暂无数据</div>
                                </el-popover>
                            </div>
                        </div>

                    </el-scrollbar>
            </div>
           
        </div>
        
    </div>
</template>

<script>
    import _ from "underscore";

    export default {
        name: "Featured",
        props: ['courseInfos', 'nodeIndex', 'chapterIndex', 'select_list', 'module_list',"zhangName","jieName"],
        data() {
            return {
                showResourseList: [],
                showPeitao: [],
                classId: 0,
                //选择的课程id
                select_course_id: this.$route.query.course_id,
                //精选课程
                featuredCourseList: [
                    {
                        class: 'courseware',
                        icon: '&#xe677;',
                        src: require('../../../assets/images/courseware.png'),
                        title: 'PPT课件',
                        index: 1,
                        mtype: 0,
                        lock:false,
                    },
                    {
                        class: 'textbook',
                        icon: '&#xe687;',
                        src: require('../../../assets/images/textbook.png'),
                        title: '教材',
                        index: 2,
                        mtype: 0,
                        lock:false,
                    },
                    {
                        class: 'micro-lesson',
                        icon: '&#xe688;',
                        src: require('../../../assets/images/micro-lesson.png'),
                        title: '微课视频',
                        index: 3,
                        mtype: 0,
                        lock:false,
                    },
                    {
                        class: 'animation',
                        icon: '&#xe68e;',
                        src: require('../../../assets/images/animation.png'),
                        title: '教学设计',
                        index: 4,
                        mtype: 0,
                        lock:false,
                    },
                    {
                        class: 'test-center',
                        icon: '&#xe678;',
                        src: require('../../../assets/images/test-center.png'),
                        title: '习题测试',
                        index: 6,
                        mtype: 0,
                        lock:false,
                    },
                    {
                        class: 'training-center',
                        icon: '&#xe66f;',
                        src: require('../../../assets/images/training-center.png'),
                        title: '实训中心',
                        index: 7,
                        mtype: 0,
                        lock:false,
                    }, 
                    // {
                    //     class: 'training-center',
                    //     icon: '&#xe66f;',
                    //     src: require('../../../assets/images/training-center.png'),
                    //     title: '实训指导',
                    //     index: 16,
                    //     mtype: 0,
                    //     lock:false,
                    // }, 
                    {
                        class: 'person-resource',
                        icon: '&#xe72d;',
                        src: require('../../../assets/images/person-resource.png'),
                        title: '参考资料',
                        index: 8,
                        mtype: 0,
                        lock:false,
                    },
                    {
                        class: 'literacy-assessment',
                        icon: '&#xe759;',
                        title: '素养评价',
                        index: 12,
                        mtype: 0,
                        lock:false,
                    },
                    {
                        class: 'teaching-activities',
                        icon: '&#xe758;',
                        src: require('../../../assets/images/person-resource.png'),
                        title: '教学活动',
                        index: 13,
                        mtype: 0,
                        lock:false,
                    },
                    {
                        class: 'ranking',
                        icon: '&#xe75b;',
                        title: '排行榜',
                        index: 14,
                        mtype: 0,
                        lock:false,
                    },
                    // {
                    //     class: 'comprehensive-evaluation',
                    //     icon: '&#xe758;',
                    //     src: require('../../../assets/images/person-resource.png'),
                    //     title: '综合评价',
                    //     index: 15,
                    //     mtype: 0,
                    //     lock:false,
                    // },
                    {
                        class: 'training-center',
                        icon: '&#xe72e;',
                        src: require('../../../assets/images/training-center.png'),
                        title: '配套材料',
                        index: 9,
                        mtype: 0,
                        lock:false,
                    },
                ],
                //应用列表
                appList: [],
                //资源类型
                adminResourcesTypeList: [],
                //是否显示查看应用详情弹窗
                dialogAppDetail: false,
                //应用信息
                appInfo: {
                    appTitle: '',
                    appContent: '',
                    home_link: '',
                    shop_link: '',
                    teacher_link: '',
                },
                newTypeList: [{
                    id: 1,
                    name: '知识点'
                }, {
                    id: 2,
                    name: "素材库"
                }, {
                    id: 3,
                    name: '案例库'
                }, {
                    id: 4,
                    name: '视频'
                }, {
                    id: 5,
                    name: '相关文章'
                }],
                newTypePic: [{
                    id: 1,
                    src: require('../../../assets/img/image/know.png')
                }, {
                    id: 2,
                    src: require('../../../assets/img/image/newsucai.png')
                }, {
                    id: 3,
                    src: require('../../../assets/img/image/newanli.png')
                }, {
                    id: 4,
                    src: require('../../../assets/img/image/newvideo.png')
                }, {
                    id: 5,
                    src: require('../../../assets/img/image/article.png')
                }],
                resourceList: [],
                papersList: [],
                projectsList: [],
                courseContent: [],
                material_list: [],
                course_content: [],
                cKejian: [],
                cJiaocai: [],
                cWeike: [],
                cDonghua: [],
                cPeitao: [],
                cJiaoan: [],
                testCenter: [],
                practiceCenter: [],
                role: localStorage.getItem('role') ? Number(localStorage.getItem('role')) : 0,
                activePopoverIndex:-1,
                activeFeaturedIndex:10,
                activeName:"studentCourseIndex",
                cailiao:{
                    page:1,
                    size:20
                },
                zhangjie:0,
                jie:0,
                


            }
        },
       
        mounted() {
            this.getAllocation();
            this.courseInfo();
            this.activeName = this.$route.meta.tabName;
            // if (this.role === 4) {
            //     this.featuredCourseList.splice(3, 1);
            // }
            if(!localStorage.getItem("activeFeaturedIndex") && localStorage.getItem("activeFeaturedIndex")!=0){
                localStorage.setItem("activeFeaturedIndex",this.activeFeaturedIndex)
            }else{
                this.activeFeaturedIndex=localStorage.getItem("activeFeaturedIndex")
            }
        
            if(this.$route.path=="/qualityCourse/featured"){
                this.activeFeaturedIndex=10
            }          
            this.zhangjie=this.$route.query.zhangIndex
            this.jie=this.jieIndex
            this.getLockDetial()
         
        },
        watch: {
            nodeIndex(d) {
                this.courseInfo();
                this.activeFeaturedIndex=10
                this.getLockDetial()
              
            },
            chapterIndex(d) {
                this.courseInfo();
                this.activeFeaturedIndex=10
            },
            $route() {
                this.select_course_id = this.$route.query.course_id
            },
        },
        methods: {
            getAllocation() {
                this.$shttp.axiosGet(this.$api.getAllocation, res => {
                    if (res.code = 200) {
                        if (res.data.appcenter_ids) {
                            let appcenter_ids = JSON.parse(res.data.appcenter_ids);
                            appcenter_ids.forEach(item => {
                                this.getAppList(item.school_app_id)
                            })
                        }
                    }
                })
            },
            getAppList(id) {
                this.$shttp.axiosGetBy(this.$api.app_showApp, {id: id ? id : 0}, res => {
                        if (res.code = 200) {
                            this.appList.push(res.data.data[0])
                        }
                        //应用排序，排列顺序跟总管理员应用中心一样
                        function compare(property){
                            return function(a,b){
                                let value1 = a[property];
                                let value2 = b[property];
                                return value2 - value1;
                            }
                        }
                        this.appList.sort(compare('parent_id'));
                    }
                )
            },
            courseInfo() {
                //
                Promise.all([
                    this.courseInfoByPromise(this.select_course_id),
                ]).then(([res]) => {
                    // console.log('课程内容', res);
                    this.courseName = res.course_name;
                    this.resourceList = res.reslist;
                    this.papersList = res.papers;
                    this.projectsList = res.projects;
                    this.courseContent = res.course_content[this.chapterIndex].children[this.nodeIndex].children;
                    // console.log('课程的平台资源', this.courseContent);
                    //整理资源
                    //课件
                    this.cKejian = this.formatResources(1);
                    // console.log('1222', this.cKejian);
                    //教材
                    this.cJiaocai = this.formatResources(2);
                    // console.log('2', this.cJiaocai);
                    //微课
                    this.cWeike = this.formatResources(3);
                    // console.log('3', this.cWeike);
                    //动画
                    this.cDonghua = this.formatResources(4);
                    // console.log('4', this.cDonghua);
                    //配套材料
                    this.cPeitao = this.formatResources(5);
                    this.handleShowPeiTao();
                    // console.log('5', this.cPeitao);
                    //教案
                    this.cJiaoan = this.formatResources(6);
                    // console.log('6', this.cJiaoan);
                    //测试中心
                    this.testCenter = this.formatExams(res.papers);
                    // console.log('小测', this.testCenter);
                    //实训中心
                    this.practiceCenter = this.formatProject(res.projects);
                    // console.log('实训', this.practiceCenter);
                }).catch(err => {
                    this.$common.axiosErrorMsg(err);
                });
            },
            courseInfoByPromise(id) {
                return new Promise((resolve, reject) => {
                    let param = {
                        id
                    }
                    this.$shttp.axiosGetBy(this.$api.courseinfo, param, (res) => {
                        if (res.code === 200) {
                            resolve(res.data);
                        } else {
                            this.$message({
                                type: 'warning',
                                message: res.msg,
                                duration: 1000
                            });
                            resolve(false);
                        }
                    }, (err) => {
                        reject(err);
                    })
                });
            },
            formatExams(exams) {
                let reslist = [];
                let reslist1 = [];
                _.each(exams, (item) => {
                    let tmp = {}
                    tmp = item;
                    tmp.resource_id = item.id;
                    tmp.title = item.paper_name;
                    tmp.ctype = 4;
                    tmp.oldIndex = 6;
                    reslist.push(tmp)
                });
                //遍历出当前章节的资源
                _.each(this.courseContent, (item) => {
                    _.each(reslist, (item1) => {
                        if (item.type === 4) {
                            if (Number(item.id) === Number(item1.id)) {
                                item1.title = item.name ? item.name : item1.title
                                reslist1.push(item1);
                            }
                        }
                    })
                })
                return reslist1;
            },
            formatProject(projects) {
                let reslist = [];
                let reslist1 = [];
                _.each(projects, (item) => {
                    let tmp = {};
                    tmp = item;
                    tmp.id = item.id;
                    tmp.resource_id = item.id,
                    tmp.ctype = 5;
                    tmp.title = item.project_title;
                    tmp.oldIndex = 7;
                    reslist.push(tmp);
                });
                //遍历出当前章节的资源
                _.each(this.courseContent, (item) => {
                    _.each(reslist, (item1) => {
                        if (item.type === 5) {
                            if (Number(item.id) === Number(item1.id)) {
                                item1.title = item.name ? item.name : item1.title
                                reslist1.push(item1);
                            }
                        }
                    })
                })
                return reslist1;
            },
            formatResources(type) {
                let reslist = [];
                let reslist1 = [];
                //格式化资源的属性名，这边是查出所有的资源
                _.each(this.resourceList, (item) => {
                    let tmp = {}
                    if (Number(item.resource_type_id) === Number(type)) {
                        tmp = item;
                        tmp.id = item.resource_id;         //资源id
                        tmp.title = item.resource_title;      // 资源名称
                        tmp.ctype = 3;                         //资源位于课程内容中的标识：系统资源 => 3; 系统测试(小测) => 4；项目（实训） => 5；配套材料（教师和学校管理员自己上传）=> 6
                        tmp.oldIndex = type === 6 ? item.material_type_id : type;
                        tmp.type = 3;
                        reslist.push(tmp);
                    }
                });
                //遍历出当前章节的资源
                _.each(this.courseContent, (item) => {
                    _.each(reslist, (item1) => {
                        if (Number(item.id) === Number(item1.id)) {
                            if (item.name) {
                                item1.title = item.name
                            }
                            reslist1.push(item1);
                        }
                    })
                })
                return reslist1;
            },
            //获取资源分类列表
            getResourcesTypeList() {
                this.$http.axiosGet(this.$api.meterial_mtlTypeList, (res) => {
                    if (res.code === 200) {
                        this.adminResourcesTypeList = res.data;
                    } else {
                        this.$message.error(res.msg);
                    }
                }, (err) => {
                    console.log(err);
                })
            },
            getResourceList(index,vindex,item) {
               
                
                if(this.activeFeaturedIndex!=vindex){
                    this.activePopoverIndex=-1
                }
                this.activeFeaturedIndex=vindex
                localStorage.setItem('activeFeaturedIndex',this.activeFeaturedIndex)
                if(index<8){
                    this.$nextTick(() => {
                        let ref = 'pop'+ this.activeFeaturedIndex;
                        this.$refs[ref][0].updatePopper()
                    })
                }
                if(item.lock){
                    this.$nextTick(() => {
                        let ref = 'pop'+ this.activeFeaturedIndex;
                        this.$refs[ref][0].doClose()
                    })
                    this.$message.warning("该功能被老师关闭,并且无法进入")

                    return
                }
                this.showResourseList = [];
                switch (index) {
                    case 1:
                        this.showResourseList = this.cKejian;
                        break;
                    case 2:
                        this.showResourseList = this.cJiaocai;
                        break;
                    case 3:
                        this.showResourseList = this.cWeike;
                        break;
                    case 4:
                        this.showResourseList = this.cJiaoan;
                        break;
                    case 6:
                        this.showResourseList = this.testCenter;
                        break;
                    case 7:
                        // 实训任务-原实训中心
                        this.showResourseList = this.practiceCenter;
                        break;
                    // case 16:
                    //     // 实训指导-原实训中心
                    //     this.showResourseList = this.practiceCenter;
                    //     break;
                    case 9:
                        // 配套材料
                        if(this.$route.path!='/qualityCourse/featured'){
                            this.$router.push({
                                path: '/qualityCourse/featured',
                                query: {
                                    course_id: this.select_course_id,
                                zhangIndex: this.chapterIndex,
                                jieIndex: this.nodeIndex
                                }
                            })
                        }
                        break;
                    case 8:
                        this.$router.push({
                            path: '/qualityCourse/referenceMaterial',
                            query: {
                                course_id: this.select_course_id,
                                zhangIndex: this.chapterIndex,
                                jieIndex: this.nodeIndex,
                            }
                        })
                        break;
                    case 12:
                        // 素养评价
                        console.log("student literacy");
                        this.$router.push({
                            path: "/qualityCourse/literacy",
                            query: {
                                course_id: this.select_course_id,
                                zhangIndex: this.chapterIndex,
                                jieIndex: this.nodeIndex,
                            }
                        });
                        break;
                    case 13:
                        // 教学活动
                        this.$router.push({
                            path: "/qualityCourse/studentActivity",
                            query: {
                                course_id: this.select_course_id || localStorage.getItem("course_id"),
                                zhangIndex: this.chapterIndex || localStorage.getItem("studentChapter"),
                                jieIndex: this.nodeIndex || localStorage.getItem("studentNode"),
                                zhangName:this.zhangName || localStorage.getItem("zhangName"),
                                jieName: this.jieName || localStorage.getItem("jieName"),
                            }
                        });
                        break;
                    case 14:
                        // 排行榜
                        this.$router.push({
                            path: "/qualityCourse/leaderboard",
                            query: {
                                course_id: this.select_course_id || localStorage.getItem("course_id"),
                                zhangIndex: this.chapterIndex || localStorage.getItem("studentChapter"),
                                jieIndex: this.nodeIndex || localStorage.getItem("studentNode"),
                            }
                        });
                        break;
                    case 15:
                        // 综合数据评价
                        this.$router.push({
                            path: "/qualityCourse/student/dataEvaluationIndex",
                            query: {
                                course_id: this.select_course_id,
                                zhangIndex: this.chapterIndex,
                                jieIndex: this.nodeIndex,
                            }
                        });
                        break;
                }
            },
            //跳到课件列表页
            goToCourseWare(item,index,poverIndex) {
                console.log("item",item);
                localStorage.setItem("project_id",item.id)
                localStorage.setItem("project_type",1)
                
                this.$router.push({
                    path: '/qualityCourse/featureddetail',
                    query: {
                        course_id: this.select_course_id,
                        typeId: item.oldIndex,
                        zhangIndex: this.chapterIndex,
                        jieIndex: this.nodeIndex,
                        file_path: item.file_preview_path,
                        id: item.id,
                        resource_id:item.resource_id,
                        name:item.title

                    }
                });
                localStorage.setItem("project_id",item.id)
                this.activePopoverIndex=poverIndex
                 // 关闭popver弹框
                 let ref='pop'+index
                this.$refs[ref][0].doClose()
            },
            //查看应用详情
            viewAppDetail(item) {
                this.dialogAppDetail = true;
                this.appInfo.appTitle = item.app_name;
                this.appInfo.appContent = item.intro;
                this.appInfo.home_link = item.home_link;
                this.appInfo.shop_link = item.shop_link;
                this.appInfo.teacher_link = item.teacher_link;
            },
            changeType(id) {
                this.classId = id;
                let arr = [];
                this.cPeitao.forEach(item => {
                    if (id === 0) {
                        arr.push(item)
                    } else {
                        if (item.material_type_id === id) {
                            arr.push(item)
                        }
                    }
                })
                this.showPeitao = arr;
            },
            handleSizeChange(val) {
                // console.log(`每页 ${val} 条`);
            },
            handleShowPeiTao() {
                // let arr = [];
                // let len = this.cPeitao.length;
                // if (len > 0 && len < 12) {
                //     for (let i = 0; i < len; i++) {
                //         arr.push(this.cPeitao[i]);
                //     }
                // } else if (len > 12) {
                //     for (let j = 0; j < 12; j++) {
                //         arr.push(this.cPeitao[j]);
                //     }
                // }
                // this.showPeitao = arr;
                this.showPeitao=this.cPeitao
                // this.showPeitao=this.cPeitao.slice((this.cailiao.page-1)*this.cailiao.size,this.cailiao.page*this.cailiao.size);
            },
            handleCurrentChange(val) {
                // let arr = [];
                // let pageSize = 12;
                // let num = (val - 1) * pageSize;
                // let endNum = (val * pageSize) - 1;
                // for (let i = num; i <= endNum; i++) {
                //     arr.push(this.cPeitao[i]);
                // }
                // let newArr = arr.filter(item => {
                //     return item != undefined
                // })
                // this.showPeitao = newArr
                this.cailiao.page=val
                // this.showPeitao=[]
                // this.showPeitao=this.cPeitao.slice((this.cailiao.page-1)*this.cailiao.size,this.cailiao.page*this.cailiao.size)
            },
            getLockDetial(){
                let params={
                    course_id: this.select_course_id,
                    course_chapter: this.chapterIndex,
                    course_node: this.nodeIndex,
                    class_id: localStorage.getItem("c_id") || localStorage.getItem("class_id"),
                }
                this.$http.axiosPost(this.$api.jdCourseMenuInfo, params, res => {
                    if (res.code === 200) {
                        let arr = res.data;
                        if (arr.length != 0) {
                            this.featuredCourseList.forEach((item) => {
                            arr.forEach((data) => {
                                if (item.index == data) {
                                item.lock = true;
                                } else {
                                item.false;
                                }
                            });
                            });
                        } else {
                            this.featuredCourseList.forEach((item) => {
                            item.lock = false;
                            });
                        }
                        } else {
                        this.$message.warning(res.msg);
                        }
                                })

            }
        },
        beforeDestroy(){
           
           localStorage.removeItem("activeFeaturedIndex")
         
       }
        
    }
</script>

<style scoped lang="scss">
    .featured-content {
        display: flex;
        justify-content: start;
        width: 100%;
        height: 100%;

        .featured-index {
            display: flex;
            justify-content: start;
            width: 100%;
            height: 100%;

            .featured-left {
                display: flex;
                flex-direction: column;
                position: relative;
                flex: 1;
                width: 1%;
                background-color: #EFEFEF ;
                padding:0px 30px;
                padding-top: 5px;
                box-sizing: border-box;
                
                .featured-topbox {
                    width: 100%;
                    height: 54px;
                    z-index: 1;
                    margin-top: 16px;
                    display: flex;
                    align-items: center;                 
                    position: relative;
                    background: #FFFFFF;
                    margin-bottom: 20px;
                    border-radius: 4px;
                    

                    span {
                        display: inline-block;
                        line-height: 1;
                        font-size: 18px;
                        padding: 8px 20px;
                        border-radius: 4px;
                        font-weight: 400;
                        cursor: pointer;
                    }

                    .class-item {
                        // background: #409EFF;
                        // box-shadow: 0px 4px 8px 1px rgba(9, 95, 185, 0.17);
                        // border-radius: 20px;
                        color: #006EFF;
                    }
                }

                .featured-top {
                    flex: 1;
                    height: 1%;
                    background: #FFFFFF;
                    border-radius: 4px 4px 4px 4px;

                    ::v-deep .el-scrollbar__wrap {
                        overflow-x: hidden;
                        margin-right: -37px !important;
                    }

                    ::v-deep .el-scrollbar__view {
                        margin-right: 20px;
                    }

                    .featured-mainbox {
                        width: 100%;
                       

                        .mainbox-list {
                            width: 100%;
                            min-height: 625px;
                            padding: 20px 42px;
                            padding-bottom: 30px;
                            box-sizing: border-box;
                            // background-color: pink;


                            .dragg-box {
                                display: flex;
                                // justify-content: space-between;
                                flex-wrap: wrap;
                                // justify-content: space-evenly;
                                
                            }
                            .mainbox-list-item1{
                                width: 25%;
                                height: 80px;
                                // background-color: skyblue;
                                padding: 0 10px;
                                margin-bottom: 20px;
                                box-sizing: border-box;
                                .mainbox-list-item {
                                cursor: pointer;
                                width: 100%;
                                height: 80px;
                             
                                display: flex;
                                background: #F2F6FA;
                                // background-color: pink;
                                border-radius: 4px 4px 4px 4px;
                                border: 1px solid #E1E6F0;
                                margin-right: 3.4%;
                                align-items: center;
                                padding: 0 5px;
                                box-sizing: border-box;
                                .pic-box{
                                    width: 56px;
                                    height: 56px;
                                    // margin-left: 10px;
                                    img{
                                        width: 100%;
                                        height: 100%;
                                    }
                                }

                                .item-title {
                                    width: 230px;
                                    margin-left: 5px;
                                    white-space: nowrap; 
                                    overflow: hidden;
                                    text-overflow: ellipsis; 


                                }
                            }

                            }
                            

                            .no-data {
                                width: 100%;
                                font-size: 16px;
                                text-align: center;
                            }
                        }
                        .mainbox-list-else{
                            display: flex;
                            flex-direction: column;
                            align-items: center;
                            img{
                                margin-top: 240px;
                                width: 370px;
                                height: 200px;
                            }
                            .no-data{
                                margin-top: 37px;
                            }
                        }

                        .page-box {
                            text-align: center;
                            margin-top: 40px;
                            margin-bottom: 40px;
                        }
                    }
                }
            }
            .featured-left-copy{
                flex: 1;
                width: 1%;
                // background-color: #EFEFEF ;
            }
            .resource_navigation {
                width: 80px;
                height: 100%;
                background: #333333;
                padding: 15px 0;
                box-sizing: border-box;

                .featured-right {
                    width: 80px;
                    height: calc(100vh - 150px);

                    ::v-deep .el-scrollbar__wrap {
                        overflow-x: hidden !important;
                    }
                    .resource {
                        overflow-x: hidden;
                        .resourse_item {

                            ::v-deep .inner-box {
                                width: 100%;
                                color: #999999;
                                height: 90px;
                                display: flex;
                                align-items: center;
                                justify-content: center;
                                flex-direction: column;
                                cursor: pointer;
                                position: relative;

                                .resourse_title {
                                    margin-top: 10px;
                                    font-size: 14px;
                                }

                                .lock, .no-lock {
                                    position: absolute;
                                    top: 4px;
                                    right: 4px;
                                    font-size: 20px;
                                }
                            }

                            ::v-deep .active_resourse_item {
                                background-color: #1E1E1E !important;
                                color: #FFFFFF;

                            }
                       
                        


                        }
                        .resourse_item:hover{
                            background-color: #1E1E1E !important;
                            ::v-deep .inner-box{
                                color: #FFFFFF !important;
                            }
                          
                            
                        }


                    }

                }
            }

          
        }
    }

    .upload-resources-dialog {
        .info-form {
            .file {
                ::v-deep .el-form-item__content {
                    position: relative;
                    display: flex;
                    flex-direction: column;
                }

                .file-name {
                    display: flex;
                    position: relative;
                }

                .upload-cover {
                    width: 100px;
                    height: 30px;
                    background: #ECF5FF;
                    border: 1px solid #DCECFE;
                    border-radius: 5px;
                    color: #409EFF;
                    line-height: 30px;
                    text-align: center;
                    margin-right: 15px;

                    i.iconfont {
                        font-size: 14px;
                        margin-right: 5px;
                    }
                }

                .cover-input {
                    position: absolute;
                    top: 0;
                    width: 100px;
                    height: 30px;
                    opacity: 0;
                    cursor: pointer;
                }
            }

            .resources-class-cascader {
                width: 100%;
            }

            .select-course {
                width: 100%;
            }
        }
    }

    .app-detail-dialog {
        ::v-deep .el-dialog {
            ::v-deep .el-dialog__header {
                border-bottom: 1px solid #e6e7ea;
            }

            .title {
                text-align: center;
                margin: 0;
            }

            .content {
                display: flex;
                flex-direction: column;

                .h2 {
                    font-size: 18px;
                    font-weight: 500;
                    text-align: center;
                    margin: 10px 0;
                }

                .soft-introduction {
                    text-align: center;
                }

                .soft-content {
                    padding: 10px 50px;
                    min-height: 200px;
                }
            }

            ::v-deep .el-dialog__footer {
                border-top: 1px solid #e6e7ea;
                padding: 20px;

                a {
                    padding: 7px 20px;
                    font-size: 14px;
                    border-radius: 4px;
                    margin-right: 20px;
                }

                a.home {
                    border: 1px solid #DCDFE6;
                    color: #606266;

                    &:hover {
                        color: #409EFF;
                        border-color: #c6e2ff;
                        background-color: #ecf5ff;
                    }
                }

                a.shop {
                    color: #FFF;
                    background-color: #409EFF;
                    border-color: #409EFF;

                    &:hover {
                        background: #66b1ff;
                        border-color: #66b1ff;
                        color: #FFF;
                    }
                }
            }
        }
    }

    ::v-deep .saveTemplate {
        .el-dialog__header {
            background: #409EFF;

            span {
                color: #fff;
                font-size: 16px;
            }

            .el-icon-close {
                color: #fff;
            }
        }

        .el-dialog__body {
            padding: 70px 0px 20px 50px;
        }

        .template-box {
            display: flex;
            flex-direction: column;

            .template-box-name {
                display: flex;
                align-items: center;
                color: #333333;
                font-size: 14px;
                padding-right: 60px;
            }

            .template-box-btn {
                margin-top: 70px;
                display: flex;
                justify-content: flex-end;
                padding-right: 20px;

                .el-button {
                    margin-left: 20px;
                }
            }
        }
    }


    .select-positioning {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 60px;
        height: 60px;
        box-shadow: 0px 1px 6px 1px rgba(64, 158, 255, 0.2);
        border-radius: 10px;
        margin-left: 20px;
        //position: absolute;
        //right: -20px;
        //top: -78px;
        //z-index: 99;
        background: #409EFF;

        i {
            font-size: 29px;
            color: #9CA9C3;
        }

        .hover-two {
            background: #409EFF;
            border-radius: 10px;
            color: #FFFFFF;
            font-size: 14px;
            //line-height: 60px;
            text-align: center;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-content: center;
            font-weight: 400;
            cursor: pointer;
            align-items: center;
            width: 100%;
            height: 100%;
        }
    }


    ::v-deep .el-input__inner {
   
    background-color:#F7F8FC  !important;
    color: #6A7E93 !important;
}
.popover-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 30px;
    cursor: pointer;
    div{
        width: 200px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }
   
   
   
}
.active-popover-item{
    background-color: #1E1E1E;
    color: #ffffff;
}
.popover-item:hover{
    background-color: #1E1E1E;
    color: #ffffff;
} 



                            
</style>